export const parsePhoneForDisplay = (phoneString, countryCodes) => {
  if (!phoneString) return { countryCode: "", phoneNumber: "" };

  if (phoneString.includes("_")) {
    const phoneParts = phoneString.split("_");

    // First part is always the country code (contains +)
    const countryCode = phoneParts[0] || "";

    // Get remaining parts after country code
    const remainingParts = phoneParts.slice(1);

    let phoneNumber = "";

    // Look for the part that contains digits (phone number)
    remainingParts.forEach((part) => {
      if (part.match(/[\d\-\s\(\)\.]/)) {
        // This part contains digits, dashes, spaces, etc. - it's the phone number
        phoneNumber = part;
      } else if (!phoneNumber && part.match(/\d/)) {
        // Fallback: any part with digits
        phoneNumber = part;
      }
    });

    // If no clear phone number found, check position-based logic
    if (!phoneNumber && remainingParts.length >= 2) {
      // Check if second part looks like a phone number
      if (remainingParts[1] && remainingParts[1].match(/\d/)) {
        phoneNumber = remainingParts[1];
      } else {
        phoneNumber = remainingParts[0];
      }
    } else if (!phoneNumber && remainingParts.length >= 1) {
      // Only one part remaining, check if it has digits
      if (remainingParts[0].match(/\d/)) {
        phoneNumber = remainingParts[0];
      }
    }

    return { countryCode, phoneNumber };
  } else if (phoneString.includes("+")) {
    // Case: +24788888AC (without underscores)
    const countryCodeText = phoneString.match(/[A-Za-z]+$/)?.[0] || "";

    // Find country code by trying different lengths
    let matchedCountryCode = "";

    for (let i = 1; i <= 4; i++) {
      const potentialCode = phoneString.substring(0, i + 1);
      const codeNumber = potentialCode.substring(1);

      // You might need to replace 'countryCodes' with your actual array name
      const foundCode = countryCodes?.find(
        (code) => code.number === codeNumber
      );
      if (foundCode) {
        matchedCountryCode = potentialCode;
      }
    }

    if (matchedCountryCode) {
      const countryCode = matchedCountryCode;
      const withoutCountryCode = phoneString.replace(countryCode, "");
      const phoneNumber = withoutCountryCode.replace(countryCodeText, "");
      return { countryCode, phoneNumber };
    } else {
      // Fallback: assume first 4 characters are country code
      const countryCode = phoneString.substring(0, 4);
      const withoutCountryCode = phoneString.replace(countryCode, "");
      const phoneNumber = withoutCountryCode.replace(countryCodeText, "");
      return { countryCode, phoneNumber };
    }
  }

  // If no + sign, return as is
  return { countryCode: "", phoneNumber: phoneString };
};

export const parsePhoneNumberForInput = (phoneString, countryCodes = []) => {
  if (!phoneString) {
    return {
      countryCode: "",
      phoneNumber: "",
      countryCodeText: "",
    };
  }

  const isCountryCode = (str) => str && /^[A-Z]{2,3}$/.test(str);

  let countryCode = "";
  let phoneNumber = "";
  let countryCodeText = "";

  if (phoneString.includes("_")) {
    console.log("Parsing phone:", phoneString);
    const parts = phoneString.split("_");

    if (parts.length >= 3) {
      // Format: +247_88888_AC or +247_AC_88888
      countryCode = parts[0];
      if (isCountryCode(parts[1])) {
        // Format: +247_AC_88888
        countryCodeText = parts[1];
        phoneNumber = parts[2] || "";
      } else if (isCountryCode(parts[2])) {
        // Format: +247_88888_AC
        phoneNumber = parts[1];
        countryCodeText = parts[2];
      } else {
        // Neither is a country code, assume parts[1] is phone number
        phoneNumber = parts[1];
        countryCodeText = parts[2] || "";
      }
    } else if (parts.length === 2) {
      // Handle different 2-part scenarios
      if (parts[0] && parts[1] === "") {
        // Format: 4234213423_ (number ending with underscore)
        countryCode = "";
        phoneNumber = parts[0];
        countryCodeText = "";
      } else if (parts[0].startsWith("+")) {
        // Format: +247_88888 or +247_AC
        countryCode = parts[0];
        if (isCountryCode(parts[1])) {
          countryCodeText = parts[1];
          phoneNumber = "";
        } else {
          phoneNumber = parts[1];
          countryCodeText = "";
        }
      } else {
        // Format: 88888_AC or similar
        phoneNumber = parts[0];
        countryCodeText = isCountryCode(parts[1]) ? parts[1] : "";
      }
    } else if (parts.length === 1) {
      // Single part after splitting
      phoneNumber = parts[0];
    }
  } else if (phoneString.includes("+") && !phoneString.includes("_")) {
    // Format: "+247 88888" (space separated)
    const spaceParts = phoneString.split(" ");
    countryCode = spaceParts[0];
    phoneNumber = spaceParts[1] || "";

    // Try to find matching country code text from countryCodes array
    if (countryCodes.length > 0) {
      const matchingCountry = countryCodes.find(
        (country) => country.number == countryCode.slice(1)
      );
      countryCodeText = matchingCountry?.code || "";
    }
  } else {
    // Fallback for plain numbers without formatting
    countryCode = "";
    phoneNumber = phoneString;
    countryCodeText = "";
  }

  return {
    countryCode,
    phoneNumber,
    countryCodeText,
  };
};
